/* eslint-disable */
const awsmobile = {
  aws_project_region: process.env.VUE_APP_AWS_REGION || 'eu-central-1',
  aws_cognito_identity_pool_id:
    process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID || 'eu-central-1:c87a514c-f333-41e3-9a41-ee2f5140eae0',
  aws_cognito_region: process.env.VUE_APP_AWS_REGION || 'eu-central-1',
  aws_user_pools_id: process.env.VUE_APP_COGNITO_USER_POOL_ID || 'eu-central-1_ZaDZEGRnK',
  aws_user_pools_web_client_id: process.env.VUE_APP_COGNITO_CLIENT_ID || '4131akq9drq749jb0d0g4qtvq7',
  oauth: {},
};

export default awsmobile;
